import { useV2Api } from '@/plugins/api/openapi'
import router from '@/router'
import store from '@/store'
import { useAlert } from '@/v2/composables/alert/alert'
import { defineStore, storeToRefs } from 'pinia'
import { nextTick, ref, watch } from 'vue'
import { useAuthStore } from './auth'

export const useInactivityStore = defineStore('inactivity', () => {
  const authStore = useAuthStore()
  const alert = useAlert()
  const api = useV2Api()

  const inactivityTimeoutId = ref<number>()

  const { session } = storeToRefs(authStore)

  watch(
    session,
    () => {
      if (!session.value) {
        return
      }

      init(session.value.session.duration)
    },
    { deep: true, immediate: true },
  )

  function init(duration: number) {
    if (inactivityTimeoutId.value) {
      window.clearTimeout(inactivityTimeoutId.value)
      inactivityTimeoutId.value = undefined
    }

    inactivityTimeoutId.value = window.setTimeout(async () => {
      await api.auth.logoutSession(authStore.session!.session.id)
      await store.dispatch('auth/clearCredentials', null, { root: true })
      authStore.setToken(null)
      await nextTick()
      await router.push('/login')
      alert.error({
        message: 'Sessão expirada por inatividade',
        description: 'Faça login novamente',
      })
    }, duration)
  }

  return { inactivityTimeoutId }
})
